import React from 'react';

export const DerivedText = ({ value, className, formatText }: any) => {
  const formatted = React.useMemo(() => {
    return formatText(value);
  }, [formatText, value]);
  return <span className={className}>{formatted}</span>;
};
